import location from './location';

const env = {
  location,
};

export default env;
